import { defineStore } from "pinia";
import { ref } from 'vue';

// Padrões da bobina térmica mais comum (80mm) — usados quando o operador
// nunca configurou nada neste terminal ainda.
const DEFAULTS = {
    width: 80,
    fontSize: 12,
    margin: 4,
};

/**
 * Configuração de impressão do recibo térmico (ver #recibo-impressao em
 * PdvView.vue). Fica em localStorage, não no backend: é uma característica
 * da impressora conectada a este terminal/computador, não do operador ou
 * da loja — cada PDV pode ter uma impressora diferente.
 */
export const printSettings = defineStore('printSettings', () => {
    const width = ref(Number(localStorage.getItem('printWidth')) || DEFAULTS.width);
    const fontSize = ref(Number(localStorage.getItem('printFontSize')) || DEFAULTS.fontSize);
    const margin = ref(Number(localStorage.getItem('printMargin')) || DEFAULTS.margin);

    function update({ width: newWidth, fontSize: newFontSize, margin: newMargin }) {
        width.value = Number(newWidth) || DEFAULTS.width;
        fontSize.value = Number(newFontSize) || DEFAULTS.fontSize;
        margin.value = Number(newMargin) || DEFAULTS.margin;

        localStorage.setItem('printWidth', width.value);
        localStorage.setItem('printFontSize', fontSize.value);
        localStorage.setItem('printMargin', margin.value);
    }

    return { width, fontSize, margin, update, DEFAULTS };
})
